import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import AllSalaryAddPopup from "../../../../components/modelpopup/AllSalaryAddPopup";
import Breadcrumbs from "../../../../components/Breadcrumbs";
import DeleteModal from "../../../../components/modelpopup/DeleteModal";
import SalaryListFilter from "../components/SalaryListFilter";
import { Table, Pagination, Tooltip,Spin , Space   } from "antd";
import ReactApexChart from "react-apexcharts";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip as ChartTooltip,
  Legend
} from "chart.js";

import Image from "components/Image"
import {
  itemRender,
  pageSizeOptions,
} from "utils/table";

import { SkeltonLoader } from "components/skeltonLoader";
import SalaryFilter from "components/Drawer/salaryFilterDrawer";
import { useSalary } from "../context/salaryContext";
import {getEmployeePayrollApi} from "api/services/employee"
import { formatDateHandler3 } from "utils/common";
import {Button} from "components/Button";
import { getEmployeePayrollDownloadApi } from "api/services/employee";
import { toast, Bounce } from "react-toastify";

// Add ChartDataLabels plugin
import ChartDataLabels from 'chartjs-plugin-datalabels';

// Register Chart.js components
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  ChartTooltip,
  Legend,
  ChartDataLabels  // Add this
);

const AllSalary = () => {
  const {
    searchText,
    view,
    setView,
    salaryModal,
    setSalaryModal,
    pageSettings,
    handleGridChange,
    handleChange,
    handleSearchChange,
    handleFilterDrawer,
    showFilterDrawer,

    handleFilterChange,
    filters,
    handleInputChange,
    handleApplyFilter,
    filterLoading,
    
    handleSalaryDetailPage,
    handleDateChange
  } = useSalary();
  const [chartData, setChartData] = useState({
    labels: [
      "Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ],
    datasets: [
      {
        label: "Basic Salary",
        data: [],
        borderColor: "#77B6EA",
        backgroundColor: "rgba(119, 182, 234, 0.1)",
        tension: 0.4,
        borderWidth: 2,
        pointRadius: 4,
        pointHoverRadius: 6,
        pointBackgroundColor: "#fff",
        pointBorderColor: "#77B6EA",
        pointBorderWidth: 2,
        fill: false,
        datalabels: {
          color: '#77B6EA'
        }
      },
      {
        label: "Transportation Allowance",
        data: [],
        borderColor: "#545454",
        backgroundColor: "rgba(84, 84, 84, 0.1)",
        tension: 0.4,
        borderWidth: 2,
        pointRadius: 4,
        pointHoverRadius: 6,
        pointBackgroundColor: "#fff",
        pointBorderColor: "#545454",
        pointBorderWidth: 2,
        fill: false,
        datalabels: {
          color: '#545454'
        }
      },
      {
        label: "Accommodation Allowance",
        data: [],
        borderColor: "#D3001A",
        backgroundColor: "rgba(211, 0, 26, 0.1)",
        tension: 0.4,
        borderWidth: 2,
        pointRadius: 4,
        pointHoverRadius: 6,
        pointBackgroundColor: "#fff",
        pointBorderColor: "#D3001A",
        pointBorderWidth: 2,
        fill: false,
        datalabels: {
          color: '#D3001A'
        }
      }
    ]
  });

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top',
        align: 'end',
        labels: {
          usePointStyle: true,
          padding: 20,
          boxWidth: 8,
          font: {
            size: 12
          }
        }
      },
      tooltip: {
        mode: 'index',
        intersect: false,
        backgroundColor: 'rgba(255, 255, 255, 0.95)',
        titleColor: '#333',
        bodyColor: '#333',
        borderColor: 'rgba(0, 0, 0, 0.1)',
        borderWidth: 1,
        padding: 12,
        displayColors: true,
        boxWidth: 8,
        boxHeight: 8,
        usePointStyle: true,
        callbacks: {
          label: function(context) {
            let label = context.dataset.label || '';
            if (label) {
              label += ': ';
            }
            if (context.parsed.y !== null) {
              label += new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'AED',
                maximumFractionDigits: 0
              }).format(context.parsed.y);
            }
            return label;
          }
        }
      },
      datalabels: {
        display: true,
        align: 'top',
        anchor: 'end',
        offset: 4,
        formatter: function(value) {
          // Format number with commas and add AED
          return new Intl.NumberFormat('en-US').format(value) + " AED";
        },
        font: {
          size: 11,
          weight: 'bold'
        },
        color: '#333',
        backgroundColor: 'rgba(255, 255, 255, 0.8)',
        padding: {
          top: 2,
          bottom: 2,
          left: 4,
          right: 4
        },
        borderRadius: 4,
        textStrokeColor: 'white',
        textStrokeWidth: 2,
        textShadowBlur: 10,
        textShadowColor: 'rgba(255, 255, 255, 0.8)'
      }
    },
    interaction: {
      mode: 'nearest',
      axis: 'x',
      intersect: false
    },
    scales: {
      x: {
        grid: {
          display: false
        },
        title: {
          display: true,
          text: 'Month',
          font: {
            size: 12,
            weight: 'bold'
          },
          padding: { top: 10 }
        },
        ticks: {
          font: {
            size: 11
          }
        }
      },
      y: {
        grid: {
          color: 'rgba(0, 0, 0, 0.05)',
          drawBorder: false
        },
        title: {
          display: true,
          text: 'Salary',
          font: {
            size: 12,
            weight: 'bold'
          },
          padding: { bottom: 10 }
        },
        ticks: {
          font: {
            size: 11
          },
          callback: function(value) {
            return new Intl.NumberFormat('en-US', {
              style: 'currency',
              currency: 'AED',
              maximumFractionDigits: 0,
              notation: 'compact',
              // compactDisplay: 'short'
            }).format(value);
          },
          padding: 8
        }
      }
    },
    elements: {
      line: {
        tension: 0.4
      },
      point: {
        radius: 4,
        hoverRadius: 6,
        borderWidth: 2,
        hoverBorderWidth: 3
      }
    }
  };

  const [selectedRow, setSelectedRow] = useState([]);
  





  const [expandedRows, setExpandedRows] = useState([]);
  const [loadingRow, setLoadingRow] = useState(null); 
  const [salaryDetails, setSalaryDetails] = useState({});

  const[payrollData, setPayrollData] = useState([])
  const[loading, setLoading] = useState(false)
  const[selectedYear, setSelectedYear] = useState(2025) // Default to 2025
  const[exportLoading, setExportLoading] = useState(false)
  
  useEffect(()=>{
    getPayrollData()
  },[selectedYear]) // Add selectedYear as dependency
 
  const getPayrollData = () => {
    setLoading(true)
    let filters = {
      year: selectedYear
    }
    getEmployeePayrollApi(filters).then(response=>{
      console.log(response.data, " DATAAAAA")
      setPayrollData(response.data)
      setLoading(false)
    })
  }
  
  // Year selection handler
  const handleYearChange = (value) => {
    setSelectedYear(value);
  }
  
  // Generate year options from 2025 to current year
  const currentYear = new Date().getFullYear();
  const yearOptions = [];
  // Start from 2025 and only include years up to the current year
  for (let year = 2025; year <= currentYear; year++) {
    yearOptions.push({ value: year, label: year.toString() });
  }

  useEffect(() => {
    if (payrollData.length) {
      const basicPayList = [];
      const travelList = [];
      const accList = [];

      payrollData.forEach(item => {
        basicPayList.push(item['Basic Salary']);
        travelList.push(item['Transportation Allowance']);
        accList.push(item['Accomodation Allowance']);
      });

      setChartData(prevData => ({
        ...prevData,
        datasets: [
          {
            ...prevData.datasets[0],
            data: basicPayList
          },
          {
            ...prevData.datasets[1],
            data: travelList
          },
          {
            ...prevData.datasets[2],
            data: accList
          }
        ]
      }));
    }
  }, [payrollData]);



  
  


  const columns = [
    // {
    //   title: "Emp No",
    //   dataIndex: "id",
    //   render: (text, record) => (
    //     <span className="table-avatar">
    //       {record.company_user.emp_no}
    //     </span>
    //   )  ,
    //    sorter: (a, b) => b.salary.id - a.salary.id,
    // },
    {
      title: "Payroll Period",
      dataIndex: "class_code",
      render: (text, record, index) => (
        <h2 className="table-avatar d-flex align-items-center">
      
              {
                formatDateHandler3(record?.start_date)
              }

        </h2>
      ),
    },
    
  
    {
      title: "Basic Salary",
      dataIndex: "basic_pay",
      sorter: false,
      render: (text, record) => {
  
          return(
            <span className="table-avatar">
              {record['Basic Salary']}
            </span>
          )
        
        
        },
      align:"center"
    
    },
  
    {
      title: "Accommodation Allowance",
      dataIndex: "name",
      sorter: false,
      render: (text, record) => {
          return(
            <span className="table-avatar">
              {record['Accomodation Allowance']}
            </span>
          )
      
       }  
    
    },
  
  
    {
      title: "Transportation Allowance",
      dataIndex: "transport_allowance",
      render: (text, record) => {
          return(
            <span className="table-avatar">
              {record['Transportation Allowance']}
            </span>
          )
        
       }  
    }, 
    {
      title: "Total Salary",
      dataIndex: "total_salary",
      sorter: false,
      render: (text, record) => {
       
          return(
            <span className="table-avatar">
              {record['Total Salary']}
            </span>
          )
        }
           
    
    },
    // {
    //   title: "Leave Accrual",
    //   dataIndex: "leave_accrual",
    //   sorter: true,
    //   render: (text, record) => {
       
    //     return(
    //       <span className="table-avatar">
    //         {record['Annual Leave Accrual']}
    //       </span>
    //     )
    //   }   
    
    // },
    {
      title: "Gross Salary",
      dataIndex: "gross_salary",
      sorter: false,
      render: (text, record) => (
        <span className="table-avatar">
          {/* {record.company_user.email} */}
          {record['Net Salary']}
        </span>
      )   
    
    },
    {
      title: "Total Deduction",
      dataIndex: "total_deductions",
      sorter: false,
      render: (text, record) => (
        <span className="table-avatar">
          {/* {record.company_user.email} */}
          {record['Total Deduction']}
        </span>
      )   
    
    },
    {
      title: "Net Pay",
      dataIndex: "net_pay",
      sorter: false,
      render: (text, record) => (
        <span className="table-avatar">
          {/* {record.company_user.email} */}
          {record['Net Salary']}
        </span>
      )   
    
    },
    // {
    //   title: "Comments",
    //   dataIndex: "comments",
    //   sorter: true,
    //   render: (text, record) => (
    //     <span className="table-avatar">

    //     </span>
    //   )   
    
    // },
    // {
    //   title: "Status",
    //   dataIndex: "status",
    //   sorter: false,
    //   render: (text, record) => (
    //     <span className="table-avatar">
    //       <span className="badge badge-primary" >{record.Status}</span>
    //       {/* {record.company_user.email} */}
    //     </span>
    //   )   
    
    // },
  ];



  const handleDownload = (type) => {
    let params = {
      type: type,
      year: selectedYear,
      month: selectedRow.map(item=> item.split("-")[1]).join(",")
    }
    setExportLoading(true)
    // For PDF downloads, we need to specify responseType as blob
    getEmployeePayrollDownloadApi(params, { responseType: 'blob' })
      .then(response => {
        console.log(response, " RESPONSE")
        if (type === "export") {
          // Create a blob from the PDF response
          const blob = new Blob([response.data], { type: 'application/pdf' });
          
          // Create an object URL from the blob
          const url = window.URL.createObjectURL(blob);
          
          // Create a temporary anchor element for download
          const link = document.createElement('a');
          link.href = url;
          
          // Set filename with year and timestamp
          const timestamp = new Date().getTime();
          link.download = `payroll-${selectedYear}-${timestamp}.pdf`;
          
          // Append to body, trigger download, and clean up
          document.body.appendChild(link);
          link.click();
          
          // Clean up
          setTimeout(() => {
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
          }, 100);
        } else {
          toast.success('Email sent successfully', {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Bounce,
            });
          
        }
        setExportLoading(false)
      })

      .catch(error => {
         
          toast.error(`${type == "export" ? "Download" : "Email"} failed: ` + (error.response?.data?.error || "Unknown error"), {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Bounce,
          });
          setExportLoading(false)
        console.log(error, " ERROR")
      });
  }
  const GridView = () => {
    if (loading) {
      return (
        <SkeltonLoader
          style={{height:200}}
          number={2}
          active={true}
          className="col-12 mb-2"
        />
      );
    } else {
      return (
        <>
          {payrollData.map((salary, index) => (
            <div
              className="col-md-6 col-sm-12 col-12 col-lg-3 col-xl-4"
              key={salary.id}
            >
              <div className={`profile-widget ${selectedRow.includes(salary.end_date) ? 'bg-light-info' : ''}`}>
                <div className="col-12">
                  <div className="d-flex justify-content-between align-items-start mb-2">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        checked={selectedRow.includes(salary.end_date)}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setSelectedRow(prev => [...prev, salary.end_date]);
                          } else {
                            setSelectedRow(prev => prev.filter(item => item !== salary.end_date));
                          }
                        }}
                        id={`checkbox-${salary.start_date}`}
                      />
                    </div>
                    <h4 className="user-name m-0 text-ellipsis text-start">
                      <a>{formatDateHandler3(salary?.start_date)}</a>
                    </h4>
                  </div>

                  <h5 className="user-name m-t-10 mb-0 text-ellipsis text-start">
                    <a>Total Salary : {salary['Total Salary']}</a>
                  </h5>
                  <div className="m-t-10 small text-muted text-start">Basic Salary : {salary['Basic Salary']}</div>
                  <div className="m-t-10 small text-muted text-start">Accommodation Allowance : {salary['Accomodation Allowance']}</div>
                  <div className="m-t-10 small text-muted text-start">Transportation Allowance : {salary['Transportation Allowance']}</div>
                </div>
              </div>
            </div>
          ))}
        </>
      );
    }
  };

  const rowSelection = {
    onChange: (selectedRowKeys, selected) => {
      setSelectedRow(selected.map(item=> item.end_date))
      console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRow);
    },
    getCheckboxProps: (record) => ({
      // disabled: record.name === 'Disabled User',
      // Column configuration not to be checked
      name: record.start_date,
    }),
  };

  return (
    <div>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <Breadcrumbs
            maintitle="Payroll"
            title="Dashboard"
            subtitle="Payroll"
            modal="#add_salary"
            name="Add Salary"          
            view={view}
            setSalaryModal={setSalaryModal}
            setView={setView}
          />

          {/* Year Dropdown */}
          <div className="row mb-4">
            <div className="col-12">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <h5 className="card-title me-3 mb-0">Select Year:</h5>
                    <div style={{ width: '150px' }}>
                      <select 
                        className="form-control form-select" 
                        value={selectedYear}
                        onChange={(e) => {
                          setSelectedRow([])
                          handleYearChange(parseInt(e.target.value))}}
                      >
                        {yearOptions.map(option => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* <SalaryListFilter
           filters={filters} 
           handleInputChange={handleInputChange} 
           searchPlaceholder={"Search Data"} 
           handleFilterDrawer={handleFilterDrawer}
            handleFilterChange={handleFilterChange}
            loading={loading}
          /> */}



          {/* {view == "grid" ? (
            <div className="row">    
              <GridView />
              <div className="my-2 d-flex justify-content-end ">
                <div className="col-sm-12 col-md-6 ">
                  <Pagination
                    pageSize={pageSettings?.pageSize}
                    pageSizeOptions={pageSizeOptions}
                    defaultCurrent={1}
                    current={pageSettings?.page}
                    total={pageSettings?.total}
                    itemRender={itemRender}
                    onChange={handleGridChange}
                  />
                </div>
              </div>
            </div>
          ) : ( */}
          <div className="col-md-12">
            <div className="card">
              {/* <div className="card-header">
                <h5 className="card-title">Statistics</h5>
              </div> */}
              <div className="card-body">
                <div style={{ height: "450px", padding: "20px 0" }}> {/* Increased height to accommodate labels */}
                  <Line 
                    data={chartData} 
                    options={chartOptions}
                    plugins={[ChartDataLabels]}
                  />
                </div>
              </div>
            </div>
          </div>
          {
            selectedRow?.length>0 && 
            <Space
            className="mb-3"
         
            >
              <Button disabled={exportLoading} loading={exportLoading} onClick={()=>handleDownload("export")} className="btn btn-sm btn-primary" label="Download" />
              <Button disabled={exportLoading} loading={exportLoading} onClick={()=>handleDownload("email")} className="btn btn-sm btn-primary"  label="Send as mail" />
            </Space>
          }
         

            <div className="row">
            {view == "grid" ? (
                <div className="row">    
              <GridView />
              {/* <div className="my-2 d-flex justify-content-end ">
                <div className="col-sm-12 col-md-6 ">
                <Pagination
                    pageSize={pageSettings?.pageSize}
                    pageSizeOptions={pageSizeOptions}
                    defaultCurrent={1}
                    current={pageSettings?.page}
                    total={pageSettings?.total}
                    // itemRender={itemRender}
                    onChange={handleGridChange}
                    showLessItems
                    showSizeChanger={false}
                    showQuickJumper={false}
                    hideOnSinglePage
                    itemRender={(page, type, originalElement) => {
                      if (type === "next") {
                        return (
                          <Button
                            loading={loading}
                            // disabled={loading || (selectedLeavePlanner && selectedLeavePlanner?.leave_planner?.company_user?.id != user?.id)}
                            className="btn btn-primary "
                            // type="Load More"
                            label="Load More"
                          />
                        );
                      }
                      return null;
                    }}
                  />
                </div>
              </div> */}
            </div>
            )
            :
            <div className="table-responsive">
              
            {/* <SearchBox pageSettings={pageSettings} setPageSettings={setPageSettings} /> */}
            
            <Table
            // scroll={{ x: "max-content", y: "max-content" }} // 👈 Keeps horizontal scrollbar
              className="table-striped"
              columns={columns}
              dataSource={payrollData}
              rowKey={(record) => record.start_date}
              loading={loading}
              pagination={false}
              rowSelection={{
                type: "checkbox",
                ...rowSelection,
              }}
           
              // pagination={{
              //   total: pageSettings?.total,
              //   pageSize: pageSettings?.pageSize,
              //   showSizeChanger: true,
              //   pageSizeOptions: pageSizeOptions,
              //   // showQuickJumper: true,
              
              //   position: "right",
              //   current: pageSettings?.page,
              //   showTotal: (total, range) =>
              //     `${range[0]}-${range[1]} of ${total} items`,
              // }}
              // onChange={handleChange}
            />
          </div>
          }

             
            </div>
           {/* )} */}
        </div>
      </div>

      <AllSalaryAddPopup />
      {/* Delete Modal */}
      <DeleteModal Name="Delete Salary" />

      <SalaryFilter
          searchPlaceholder={"Search Salary"}
          showFilterDrawer={showFilterDrawer}
          handleFilterDrawer={handleFilterDrawer}

          handleFilterChange={handleFilterChange}
          filters={filters}
          handleInputChange={handleInputChange}
          handleApplyFilter={handleApplyFilter}
          filterLoading={filterLoading}
          handleDateChange={handleDateChange}
/>
      {/* Delete Modal */}
    </div>
  );
};

export default AllSalary;
